<template>
  <div>
    <a @click="goTo('shipments', {}, { shipment_id: id })">
      {{ id }}
    </a>
  </div>
</template>

<script>
export default {
  name: "ShipmentLinkComp",

  data () {
    return {
    }
  },

  props: {
    item: {
      type: Object,
      required: true
    }
  },

  components: {
  },

  computed: {
    shipment () {
      return this.item.shipment
    },

    id () {
      if (this.shipment) {
        return this.shipment.sequential_id
      } else {
        return this.item.shipment_id
      }
    },
  },

  methods: {
  },

  watch: {
  },

  mounted () {
  }
}
</script>
